// Base de commentaires à la 2ème personne, piochés au hasard selon la situation, par langue.
// Convention : chaque phrase est encadrée par le même picto au début et à la fin.
export const commentsBank = Object.freeze({
  fr: {
    start: [
      '🌙 Toute la famille se cache dans le noir… 🌙', '📸 Charge ta pellicule, la chasse commence ! 📸', '🔭 Cherche les lueurs, elles ne mentent jamais ! 🔭',
      '🎞️ Chaque vue compte, ne gâche rien ! 🎞️', '🌙 Nuit sans lune, parfaite pour les portraits ! 🌙', '🕯️ Une lueur, un cadrage, un déclic ! 🕯️',
      '🎃 Les citrouilles regardent, fais-leur honneur ! 🎃', '👀 Ouvre l\'œil, ils flottent tout autour ! 👀', '🖤 Bienvenue au portrait de famille ! 🖤',
      '📷 Le viseur est prêt, à toi de jouer ! 📷', '🦇 Les chauves-souris te montrent le chemin ! 🦇', '✨ Fais briller ta collection ! ✨',
      '🧭 Explore, cadre, déclenche ! 🧭',
    ],
    win: [
      '📸 Album de famille impeccable, bravo ! 📸', '✨ Pas une vue gâchée, quel œil ! ✨', '🌙 Toute la famille sourit sur la pellicule ! 🌙',
      '🏆 Un vrai photographe de l\'au-delà ! 🏆', '🎞️ Cadrage parfait sur toute la ligne ! 🎞️', '🌟 Même Mamie fantôme est ravie ! 🌟',
      '🎃 La citrouille applaudit ! 🎃', '💜 Portraits nets, famille au complet ! 💜', '🖼️ Direct au musée des spectres ! 🖼️',
      '🥇 Le reflex n\'a jamais aussi bien visé ! 🥇', '🔦 Rien ne t\'échappe dans le noir ! 🔦', '👏 Un déclic, un fantôme, du grand art ! 👏',
    ],
    survive: [
      '😅 Pellicule presque vide, mais famille au complet ! 😅', '🎞️ Tu as gâché quelques vues, ça passe ! 🎞️', '📷 Flou artistique… mais tout le monde est là ! 📷',
      '🫣 Le dernier déclic était le bon, ouf ! 🫣', '🕯️ La lueur vacillait, tu t\'en sors ! 🕯️', '🐌 Un peu lent à cadrer, mais complet ! 🐌',
      '🎃 La citrouille a retenu son souffle ! 🎃', '🤷 Quelques photos du vide, bon… 🤷', '🏅 Portrait de famille… de justesse ! 🏅',
      '🌙 Les fantômes se sont bien moqués de toi ! 🌙', '🌫️ Tu tirais dans le brouillard, non ? 🌫️', '🥉 Album complet, mais pas très net ! 🥉',
      '🔁 La prochaine fois, vise avant de déclencher ! 🔁',
    ],
    lose: [
      '🎞️ Pellicule vide, la famille s\'est envolée ! 🎞️', '😭 Plus une seule vue, quelle poisse ! 😭', '🌙 Ils rient encore dans le noir… 🌙',
      '📷 Trop de photos du vide, dommage ! 📷', '🌑 La nuit t\'a avalé tout entier ! 🌑', '🦇 Les chauves-souris se moquent de toi ! 🦇',
      '💀 Game over pour ton reportage ! 💀', '🎃 La citrouille détourne le regard… 🎃', '🫥 Ni fantôme, ni pellicule, ni gloire ! 🫥',
      '🕸️ Pris dans la toile de tes ratés ! 🕸️', '🔦 Il fallait viser la lueur, pas l\'ombre ! 🔦', '🧠 Concentre-toi, ils ne sont pas si rapides ! 🧠',
    ],
  },
  en: {
    start: [
      '🌙 The whole family is hiding in the dark… 🌙', '📸 Load your film, the hunt is on! 📸', '🔭 Look for the glows, they never lie! 🔭',
      '🎞️ Every shot counts, waste nothing! 🎞️', '🌙 A moonless night, perfect for portraits! 🌙', '🕯️ A glow, a frame, a click! 🕯️',
      '🎃 The pumpkins are watching, do them proud! 🎃', '👀 Keep your eyes open, they float all around! 👀', '🖤 Welcome to the family portrait! 🖤',
      '📷 The viewfinder is ready, your turn! 📷', '🦇 The bats will show you the way! 🦇', '✨ Make your collection shine! ✨',
      '🧭 Explore, frame, shoot! 🧭',
    ],
    win: [
      '📸 A flawless family album, well done! 📸', '✨ Not a single wasted shot, what an eye! ✨', '🌙 The whole family is smiling on film! 🌙',
      '🏆 A true photographer of the beyond! 🏆', '🎞️ Perfect framing all the way! 🎞️', '🌟 Even Grandma ghost is delighted! 🌟',
      '🎃 The pumpkin applauds! 🎃', '💜 Sharp portraits, family complete! 💜', '🖼️ Straight to the museum of specters! 🖼️',
      '🥇 That camera never aimed so well! 🥇', '🔦 Nothing escapes you in the dark! 🔦', '👏 One click, one ghost, pure art! 👏',
    ],
    survive: [
      '😅 Film almost empty, but the family is complete! 😅', '🎞️ You wasted a few shots, but it\'ll do! 🎞️', '📷 Artistic blur… but everyone is here! 📷',
      '🫣 The last click was the right one, phew! 🫣', '🕯️ The glow was flickering, you made it! 🕯️', '🐌 A bit slow to frame, but complete! 🐌',
      '🎃 The pumpkin held its breath! 🎃', '🤷 A few pictures of nothing, well… 🤷', '🏅 A family portrait… just barely! 🏅',
      '🌙 The ghosts had a good laugh at you! 🌙', '🌫️ Were you shooting into the fog? 🌫️', '🥉 Album complete, but not very sharp! 🥉',
      '🔁 Next time, aim before you shoot! 🔁',
    ],
    lose: [
      '🎞️ Empty film, the family flew away! 🎞️', '😭 Not a single shot left, what bad luck! 😭', '🌙 They\'re still laughing in the dark… 🌙',
      '📷 Too many pictures of nothing, too bad! 📷', '🌑 The night swallowed you whole! 🌑', '🦇 The bats are making fun of you! 🦇',
      '💀 Game over for your photo story! 💀', '🎃 The pumpkin looks away… 🎃', '🫥 No ghost, no film, no glory! 🫥',
      '🕸️ Caught in the web of your misses! 🕸️', '🔦 Aim at the glow, not the shadow! 🔦', '🧠 Focus, they\'re not that fast! 🧠',
    ],
  },
});

export function pickComment(lang, situation, random = Math.random) {
  const phrases = commentsBank[lang]?.[situation] ?? commentsBank.en[situation] ?? [];
  return phrases[Math.floor(random() * phrases.length)] ?? '';
}
